import { z } from "zod";

// JSON schemas compatible with GraphQL JsonObject/JsonValue
const zJsonPrimitive = z.union([z.string(), z.number(), z.boolean(), z.null()]);
const zJsonValue: z.ZodType<unknown> = z.lazy(() =>
  z.union([zJsonPrimitive, z.array(zJsonValue), z.record(z.string(), zJsonValue)]),
);
export const zJsonObject = z.record(z.string(), zJsonValue);

// Json Query
// SYNC: Keep in sync with backend/src/infrastructure/core/types/entity.ts (zJsonQueryDTO)
const zEnumerable = z.union([z.string(), z.number(), z.array(z.string()), z.array(z.number()), z.null()]);

const zJsonQueryPath = z.object({ path: z.array(z.string()) });

export const zJsonQuery = z.union([
  zJsonQueryPath.extend({ equals: zEnumerable }),
  // eslint-disable-next-line camelcase
  zJsonQueryPath.extend({ array_contains: zEnumerable }),
  zJsonQueryPath.extend({ not: zEnumerable }),
  // eslint-disable-next-line camelcase
  zJsonQueryPath.extend({ string_starts_with: z.string() }),
  // eslint-disable-next-line camelcase
  zJsonQueryPath.extend({ string_ends_with: z.string() }),
]);

export type JsonQuery = z.infer<typeof zJsonQuery>;

export const zArrayQuery = z.union([z.object({ in: z.array(z.string()) }), z.object({ notIn: z.array(z.string()) })]);
